import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Bloco de identificação de uma pessoa (ou de uma empresa) na linha de tabela: retrato à esquerda
 * e, ao lado, protocolo, nome e inscrição empilhados.
 *
 * Vive em `shared/` porque serve duas features — a Central de Transferências e o arquivo de
 * serviços — e porque nem sempre retrata um médico: em pessoa jurídica o nome exibido é a razão
 * social da empresa e o rosto é o do diretor técnico. Repetido em cada tela, o bloco divergiria na
 * primeira alteração.
 *
 * É célula customizada, e não o tipo `perfil` do CustomTable, porque aquele desenha retrato e nome
 * e nada mais: o badge do protocolo vai ACIMA do nome, e isso não tem equivalente declarativo.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-identificacao-pessoa',
    standalone: true,
    templateUrl: './identificacao-pessoa.html',
    styleUrl: './identificacao-pessoa.scss'
})
export class IdentificacaoPessoa {
    /** Retrato da pessoa (ou da empresa). Ausente cai nas iniciais, e depois no ícone. */
    readonly foto = input<string | null>(null);
    readonly iniciais = input<string | null>(null);
    readonly nome = input<string>('');
    /** Número da solicitação, no badge acima do nome. */
    readonly protocolo = input<string>('');
    /** Inscrição, no formato `CRM 5224/DF`. Vazia faz a linha sumir, sem placeholder. */
    readonly inscricao = input<string>('');

    /**
     * Nome de quem o retrato mostra, quando ele NÃO é a pessoa nomeada ao lado — em pessoa
     * jurídica o rosto é do diretor técnico e o nome exibido é o da empresa.
     *
     * Vazio, o padrão, mantém o retrato decorativo (`aria-hidden`, `alt` vazio): em pessoa física a
     * foto retrata exatamente o nome que já se lê ao lado, e anunciá-la seria repetição.
     */
    readonly rotuloRetrato = input<string>('');
}
